import { postCommonConfigPageAction } from '@/services/yizhe-web/gonggongfenlei';
import { Image, Modal } from 'antd';
import moment from 'moment';
import { useState } from 'react';
import './index.less';
const ModalNotice = () => {
  const [open, setOpen] = useState(false);
  return (<>
    <div
      className="share-warp"
      onClick={async () => {
        await postCommonConfigPageAction({ action_type: 1 });
        setOpen(true);
      }}
    >
      <div className="share-btn" />
      <span>分享有奖</span>
    </div>
    <Modal
      className="modal-share-warp"
      open={open}
      style={{ padding: 0 }}
      width={1200}
      onCancel={() => {
        setOpen(false);
      }}
      footer={null}
    >
      <Image
        src={`https://dafeiimg.huole.cn/yizhe/icon/202304share_rewards_activity.png?t=${moment().format(
          'YYYY-MM-DD HH:MM:SS',
        )}`}
        style={{ borderRadius: '4px' }}
        preview={false}
      />
    </Modal>
  </>);
};
export default ModalNotice;
